import { useBuildVars } from 'src/config';
import { useMutation } from 'react-query';
import { useApiBlobDownloadNew, useApiPost } from 'src/api/api-hooks';
import { useApiHeaders } from 'src/api/useApiHeaders';

export function useSageSsePost() {
  const apiPost = useApiPost<Response>({
    host: process.env.REACT_APP_CHAT_API_BASE,
  });
  const getApiHeaders = useApiHeaders();

  return async (query: string) => {
    const headers = await getApiHeaders({
      Accept: 'text/event-stream',
    });
    const userId = headers['IM-UserName'] || headers['IM-UserID'] || '';

    return apiPost(
      '/sage/v1/sageagent/run_sse',
      {
        query,
        session_id: '',
        user_id: userId,
      },
      undefined,
      { Accept: 'text/event-stream' },
      true
    );
  };
}

export function useVenderProgramsDownloadFile(params: { file_id: string }) {
  const buildVars = useBuildVars();
  const apiGetDownload = useApiBlobDownloadNew({ host: buildVars.VP_API_BASE });
  let path = '/sage/v1/sageagent';
  if (params.file_id) {
    // Ensure no double slash
    const cleanFileId = params.file_id.startsWith('/')
      ? params.file_id.slice(1)
      : params.file_id;
    path += `/${cleanFileId}`;
  }
  return useMutation(() => apiGetDownload(path));
}
